// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const WrapperLinks = styled.div`
  display: flex;
  justify-content: end;
  gap: 24px;
  flex-wrap: wrap;
  width: 100%;
  padding: 26px 34px 35px;
`;

export const BeautyButton = styled.a<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    display: flex;
    align-items: center;
    color: ${isDark ? theme.colors.secondary.main : theme.colors.primary.main};
    gap: 4px;
    cursor: pointer;

    :hover {
      color: ${
        isDark ? theme.colors.secondary.light : theme.colors.primary.lighter
      };
    }
  `,
);

export const Title = styled.p<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    display: flex;
    align-items: center;
    color: ${isDark ? theme.colors.base.lighter : theme.colors.gray.dark};
    gap: 4px;
  `,
);
